import TouristAttractionList from "../components/TouristAttractionList";

const TouristAttraction = () => {
  return (
    <>
      <TouristAttractionList />
    </>
  );
};

export default TouristAttraction;
